// Query-Keys und Echtzeit-Abgleich für geplante Nachrichten (Socket-Ereignis SCHEDULED_MESSAGE_UPDATE).
import type { ScheduledMessageDto, ScheduledStatus } from '@lagerfeuer/shared';
import type { QueryClient } from '@tanstack/react-query';

export type ScheduledFilter = ScheduledStatus | 'all';

/** Präfix aller Listen-Queries geplanter Nachrichten. */
export const SCHEDULED_KEY = ['extras', 'scheduled'] as const;
export const scheduledListKey = (filter: ScheduledFilter) => [...SCHEDULED_KEY, filter] as const;

/** Sortierung: ausstehende aufsteigend (nächste zuerst), sonst absteigend (neueste zuerst). */
export function sortScheduled(items: ScheduledMessageDto[], filter: ScheduledFilter): ScheduledMessageDto[] {
  const dir = filter === 'PENDING' ? 1 : -1;
  return [...items].sort((a, b) => dir * (new Date(a.sendAt).getTime() - new Date(b.sendAt).getTime()));
}

/** Ein Update in alle gecachten Listen einspielen (passt der Status nicht zum Filter → entfernen). */
export function applyScheduledUpdate(queryClient: QueryClient, dto: ScheduledMessageDto): void {
  for (const [key, data] of queryClient.getQueriesData<ScheduledMessageDto[]>({ queryKey: SCHEDULED_KEY })) {
    if (!data) continue;
    const filter = (key[2] ?? 'all') as ScheduledFilter;
    const without = data.filter((s) => s.id !== dto.id);
    const matches = filter === 'all' || filter === dto.status;
    queryClient.setQueryData<ScheduledMessageDto[]>(key, sortScheduled(matches ? [...without, dto] : without, filter));
  }
}
